import { AlertTriangle, Database, ExternalLink } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

interface DomainNotConfiguredProps {
  hostname: string;
}

export function DomainNotConfigured({ hostname }: DomainNotConfiguredProps) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/30 flex items-center justify-center p-4">
      <Card className="max-w-lg w-full border-destructive/20">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center">
            <AlertTriangle className="w-8 h-8 text-destructive" />
          </div>
          <CardTitle className="text-2xl">Domain Not Configured</CardTitle>
          <CardDescription className="text-base">
            This domain hasn't been set up yet
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-muted/50 rounded-lg p-4 font-mono text-sm text-center break-all">
            {hostname}
          </div>
          
          <div className="space-y-3 text-sm text-muted-foreground">
            <p className="font-medium text-foreground">To configure this domain:</p>
            <ol className="list-decimal list-inside space-y-2 ml-2">
              <li>Add a record to the <code className="bg-muted px-1.5 py-0.5 rounded text-xs">generators</code> table</li>
              <li>Link the domain in <code className="bg-muted px-1.5 py-0.5 rounded text-xs">generator_domains</code> table</li>
              <li>Set <code className="bg-muted px-1.5 py-0.5 rounded text-xs">is_active = true</code> on the generator</li>
            </ol>
          </div>

          <div className="flex items-center gap-2 p-3 bg-amber-500/10 border border-amber-500/20 rounded-lg text-sm">
            <Database className="w-4 h-4 text-amber-600 shrink-0" />
            <span className="text-amber-700 dark:text-amber-400">
              Check your Supabase database configuration
            </span>
          </div>

          <div className="pt-2 flex justify-center">
            <Button variant="outline" size="sm" asChild>
              <a 
                href="https://docs.lovable.dev" 
                target="_blank" 
                rel="noopener noreferrer"
                className="gap-2"
              >
                View Documentation
                <ExternalLink className="w-3.5 h-3.5" />
              </a>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
